"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseApi = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var api_1 = require("./api");
var StorageWithExpiration_1 = require("./StorageWithExpiration");
var BaseApi = /** @class */ (function () {
    function BaseApi(config) {
        this.storageWithExpiration = null;
        this.currentPromise = null;
        this.config = config;
        this.initializeStorageWithExpiration();
    }
    BaseApi.prototype.getData = function (params) {
        if (params === void 0) { params = null; }
        var cachedData = this.getStoredData(params);
        if (cachedData) {
            return Promise.resolve(cachedData);
        }
        return this.loadData(params);
    };
    BaseApi.prototype.loadData = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.callApi(this.config.url, params)];
                    case 1:
                        data = _a.sent();
                        this.setDataToStorage(data, params);
                        return [2 /*return*/, data];
                }
            });
        });
    };
    BaseApi.prototype.callApi = function (url, params) {
        var _this = this;
        var countryHeaders = {};
        if (this.waitForInProgress() && this.currentPromise) {
            return this.currentPromise;
        }
        if (this.config.locationApiKey) {
            countryHeaders['x-api-key'] = this.config.locationApiKey;
        }
        var headers = tslib_1.__assign(tslib_1.__assign({}, this.createHeaders()), countryHeaders);
        // for Application Insights
        var startTime = Date.now();
        this.currentPromise = api_1.api(url, params, headers)
            .then(function (response) {
            _this.currentPromise = null;
            if (response.status !== 200) {
                _this.throwException(response.statusText, response);
            }
            return response;
        })
            .then(function (response) {
            _this.trackApiCall(response, headers, url, startTime);
            return response.data;
        })
            .catch(function (reason) {
            _this.currentPromise = null;
            _this.throwException(reason.message, reason.response);
        });
        return this.currentPromise;
    };
    BaseApi.prototype.getStoredData = function (params) {
        var result = null;
        if (this.canUseStorage()) {
            var jsonData = this.storageWithExpiration.getDataFromStorage(this.config.storageKey);
            result = this.deserialize(jsonData, params);
        }
        return result;
    };
    BaseApi.prototype.setDataToStorage = function (data, params) {
        if (this.canUseStorage()) {
            var dataToStore = this.serialize(data, params);
            if (dataToStore) {
                var _a = this.config, storageKey = _a.storageKey, storageExpirationTime = _a.storageExpirationTime;
                this.storageWithExpiration.setDataToStorage(storageKey, dataToStore, storageExpirationTime);
            }
        }
    };
    BaseApi.prototype.initializeStorageWithExpiration = function () {
        if (this.config && this.config.storage) {
            this.storageWithExpiration = new StorageWithExpiration_1.default(this.config.storage);
        }
    };
    BaseApi.prototype.canUseStorage = function () {
        return this.storageWithExpiration && !!this.config.storageKey;
    };
    BaseApi.prototype.waitForInProgress = function () {
        return this.config && this.config.waitForInProgress;
    };
    BaseApi.prototype.throwException = function (message, responseData, name) {
        if (name === void 0) { name = ''; }
        var apiError = new Error(message);
        apiError.name = name;
        apiError.responseData = responseData;
        throw apiError;
    };
    BaseApi.prototype.createHeaders = function () {
        return null;
    };
    BaseApi.prototype.serialize = function (data, _params) {
        return JSON.stringify(data);
    };
    BaseApi.prototype.deserialize = function (data, _params) {
        return app_1.JSONService.parse(data);
    };
    BaseApi.prototype.trackApiCall = function (response, headers, url, startTime) {
        if (headers &&
            typeof window !== 'undefined' &&
            'appInsights' in window &&
            'Microsoft' in window &&
            'AI' in window) {
            appInsights.trackDependency(Microsoft.ApplicationInsights.UtilHelpers.newId(), 'GET', url, "GET " + url, Date.now() - startTime, response.status === 200, response.status, {
                appTrack: true,
                requestId: headers.requestId,
            });
        }
    };
    return BaseApi;
}());
exports.BaseApi = BaseApi;
exports.default = BaseApi;
